module.exports = __webpack_public_path__ + "media/country_flags/co-669e170a.png";